import { render } from "./ProjectsHeader.vue?vue&type=template&id=b198c0b0"
import script from "./ProjectsHeader.vue?vue&type=script&lang=js"
export * from "./ProjectsHeader.vue?vue&type=script&lang=js"

import exportComponent from "/home/deployuser/staging/immivo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__